import cookie from 'react-cookies';

class GlobalStore{

    static getInstance() {
        if (this.shopInstance == null) {
            this.dataObjectForCookies = new Object();
            this.shopInstance = new GlobalStore();
        }
        return this.shopInstance;
    };

    shopInstance = null;

    tmpCookieObj; // = cookie.load('GlobalStoreCookie');

    _data = [];

    dataObjectForCookies = (cookie.load('GlobalStoreCookie') === undefined) ?
        {} :
        (typeof cookie.load('GlobalStoreCookie') === 'string') ? 
            JSON.parse(cookie.load('GlobalStoreCookie')):
            cookie.load('GlobalStoreCookie'); //synchronize with the dataObject
    ;

    data = new Proxy(this._data, {
        get: function(target, name) {
            // console.log("зловиу, getter was called for " + name);
            return target[name];

        },
        set: function (target, name, value) {
            // console.log("записау" + this._arr);
            GlobalStore.getInstance().dataObjectForCookies[name] = value;
            target[name] = value;


            let expires = new Date();
            expires.setDate(expires.getDate() + 14);


            // if (name === 'currentStep' && value === 5 || name === 'currentStep' && value === 4) {
            //     GlobalStore.getInstance().dataObjectForCookies['doctors'] = undefined;
            //     console.log(JSON.stringify(GlobalStore.getInstance().dataObjectForCookies));
            //     cookie.save(
            //         'GlobalStoreCookie',
            //         JSON.stringify(GlobalStore.getInstance().dataObjectForCookies), //{path: "/", domain: "localhost"}
            //     );
            // }else {
                cookie.save(
                    'GlobalStoreCookie',
                    JSON.stringify(GlobalStore.getInstance().dataObjectForCookies), //{path: "/", domain: "localhost"}
                );
            // }
            // console.log("hammasoskari cookie saved");
            return true;
        }
    });

    initialize() {

        // console.log("initialize started");
        if ((cookie.load('GlobalStoreCookie') === undefined) ) {
            // console.log("constructor undefined");
            // console.log("constructor undefined after data assignment");
        } else {
            console.log(cookie.load('GlobalStoreCookie'));
            this.tmpCookieObj = cookie.load('GlobalStoreCookie');
            let arr = [];
            for( var i in this.tmpCookieObj ) {
                if (this.tmpCookieObj.hasOwnProperty(i)) {
                    arr[i] = this.tmpCookieObj[i];
                }
            }
            for (var i in arr) {
                this.data[i] = arr[i];
            }
            // console.log("after reading _data: "); console.log(this._data);
        }
        console.log("constructor ended");
    }
}

export default GlobalStore;




// WEBPACK FOOTER //
// ./src/store/GlobalStore.jsx